const getVisibleMenuItems = (navigation) => {
  const items = [];
  for (const item of navigation) {
    if (item.kind === "widget") {
      items.push(item);
    } else if (item.kind === "leaf") {
      if (canAccessMenuItem(item)) {
        items.push(item);
      }
    } else if (item.kind === "category") {
      const children = item.children.filter(canAccessMenuItem);
      if (children.length > 0) {
        items.push({ ...item, children });
      }
    }
  }
  return items;
};
const canAccessMenuItem = (item) => {
  if (item.kind === "widget") {
    return true;
  }
  if (item.kind === "leaf") {
    if (item.visibilityHandlers) {
      return item.visibilityHandlers.every((handler) => handler());
    }
    return true;
  }
  if (item.kind === "category") {
    return item.children.some(canAccessMenuItem);
  }
  return false;
};
export {
  getVisibleMenuItems
};
